import { render } from "./SimilarRecommendEdit.vue?vue&type=template&id=20a3bee8&ts=true"
import script from "./SimilarRecommendEdit.vue?vue&type=script&lang=ts"
export * from "./SimilarRecommendEdit.vue?vue&type=script&lang=ts"

import "./SimilarRecommendEdit.vue?vue&type=style&index=0&id=20a3bee8&lang=stylus&scope=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__